/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { Task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { DATA_INDEX_TYPE_ICONS } from 'cio/utils/data-index';
import EventModel from 'cio/models/event';
import LogModel from 'cio/models/log';
import AttributeModel from 'cio/models/attribute';
import EnvironmentService from 'cio/services/environment';

interface DataIndexItemArgs {
  item: AttributeModel | EventModel;
  createCampaignTask: Task<unknown, []>;
  createSegmentTask: Task<unknown, []>;
  fetchLogsTask: Task<LogModel[], []>;
}

export default class DataIndexItem extends Component<DataIndexItemArgs> {
  @service environment!: EnvironmentService;

  @tracked isShowingSendTestEventModal = false;
  @tracked log: LogModel | null = null;

  get itemIcon() {
    return DATA_INDEX_TYPE_ICONS[this.args.item.type];
  }

  @action
  onSendTestEventWithLog(log: LogModel) {
    this.log = log;
    this.isShowingSendTestEventModal = true;
  }

  @action
  closeSendTestEventModal() {
    this.log = null;
    this.isShowingSendTestEventModal = false;
  }
}
